import { useEffect, createContext } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate, useParams } from "react-router-dom";
import {
  Button,
  Modal,
  Space,
  Spin,
  Card,
  Row,
  Col,
  Flex,
  Dropdown,
  MenuProps,
} from "antd";

import { DownOutlined } from "@ant-design/icons";

import ObjectForm from "components/Admin/ObjectForm";

import { RootState } from "Redux/store";
import { fetchDomain, updateDomain, deleteDomain } from "Redux/Admin/GoalsManager/Domains/action";

import { settings, initialSettings, initialValues } from './const';
import { ADMIN_PATH } from "utils/routes";

const Domain = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { id } = useParams<{ id: string }>();
  const isNew = id === 'new';

  const { entities, loading } = useSelector((state: RootState) => state.fetchDomains);

  const [modal, contextHolder] = Modal.useModal();

  const ReachableContext = createContext<string | null>(null);

  useEffect(() => {
    if (id && !isNew) {
      dispatch(fetchDomain(id));
    }
  }, [dispatch, isNew, id]);

  const onFinish = (values: any) => {
    if (id && !isNew) {
      dispatch(updateDomain(values, id));
    }
  };

  if (!id) {
    navigate(`${ADMIN_PATH}/goals/system/domains`, { replace: true });
    return null;
  }

  const domain = isNew ? initialValues : entities[id];

  if (!domain) {
    return <Spin />;
  }

  const menuItems: MenuProps['items'] = [
    /* {
      label: 'View Areas',
      key: '1',
    }, */
    {
      label: 'Delete Domain',
      key: '2',
      danger: true,
    }
  ];

  const modalConfig = {
    title: 'Delete the domain?',
    content: <span>Are you sure you want to delete the domain <b>{domain.id}</b>?</span>,
    confirmLoading: true
  };

  const handleMenuClick: MenuProps['onClick'] = async (e) => {
    /* if (e.key === '1') {
      navigate(`${ADMIN_PATH}/goals/journeys/user-areas/?masterplan=${id}`);
    }
    else  */if (e.key === '2') {
      const confirmed = await modal.confirm(modalConfig);

      if (confirmed) {
        dispatch(deleteDomain(id, () => {
          navigate(`${ADMIN_PATH}/goals/system/domains`, { replace: true });
        }));
      }
    }
  };

  const menuProps = {
    items: menuItems,
    onClick: handleMenuClick,
  };

  return (
    <ReachableContext.Provider value="Light">
      <div style={{ display: "flex", flexDirection: "column", height: "100%" }}>
        <Row>
          <Col span={12}>
            <Flex
              gap="middle"
              align="center"
              justify="space-between"
              style={{ marginBottom: 16 }}
            >
              <Link to={`${ADMIN_PATH}/goals/system/domains`}>Back</Link>
            </Flex>

            <Card title={`${isNew ? 'Create' : '' } Domain`} extra={
              isNew ? null : <Dropdown menu={menuProps} placement="bottom">
                <Button>
                  <Space>
                    Manage Domain
                    <DownOutlined />
                  </Space>
                </Button>
              </Dropdown>
            }>
              <ObjectForm
                data={domain}
                settings={isNew ? initialSettings : settings}
                loading={loading}
                onFinish={onFinish}
              />
            </Card>
          </Col>
        </Row>
      </div>

      {contextHolder}
    </ReachableContext.Provider>
  );
}

export default Domain;
